import { Font } from '@pdfme/common';

export const font: Font = {
  roboto: {
    data: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
    fallback: true,
  },
  robotoBold: {
    data: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
  },
  robotoItalic: {
    data: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
  },
  glacialBold: {
    data: 'https://cdn.jsdelivr.net/gh/mmfilesi/the-bit-theme@master/dist/fonts/glacialindifference-bold.ttf',
  },
  glacialRegular: {
    data: 'https://cdn.jsdelivr.net/gh/mmfilesi/the-bit-theme@master/dist/fonts/glacialindifference-regular.ttf',
  },
  arialMtBold: {
    data: 'https://cdn.jsdelivr.net/gh/couch4/surf_app@master/public/assets/fonts/ArialMT/ArialMT-Bold.ttf',
  },
  arialMtRegular: {
    data: 'https://cdn.jsdelivr.net/gh/zregvart/with-aes@master/pdfbox/src/main/resources/org/apache/pdfbox/resources/ttf/ArialMT.ttf',
  },
};

export default font;
